export default function Acuerdo() {


  return (
    <div className="w-full h-screen">
    <iframe
      src="/pdf/acuerdo-servicio.pdf"
      className="w-full h-full"
      title="Visor PDF"
    />
  </div>
  )
}
